import PrepaidCardApi from '@apis/prepaid/PrepaidCardApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import {
    GetHistoriesParams,
    GetPrepaidCardTransactionsParams,
} from '@models/prepaidCard';

const userPrepaidCardQueries = createQueryKeys('userPrepaidCard', {
    list: () => ({
        queryKey: ['list'],
        queryFn: () => PrepaidCardApi.getPrepaidCards(),
    }),
    detail: (id: string) => ({
        queryKey: ['detail', id],
        queryFn: () => PrepaidCardApi.getPrepaidCard(id),
    }),
    favoriteList: (userId: string) => ({
        queryKey: ['userPrepaidCardFavorite', userId],
        queryFn: () => PrepaidCardApi.getFavoritePrepaidCards(),
    }),
    /** @deprecated getHistories 사용 권장 */
    transactions: (id: string, params: GetPrepaidCardTransactionsParams) => ({
        queryKey: [id, params],
        queryFn: () => PrepaidCardApi.getPrepaidCardTransactions(id, params),
    }),
    histories: (id: string, params: GetHistoriesParams) => ({
        queryKey: ['histories', id, params],
        queryFn: () => PrepaidCardApi.getHistories(id, params),
    }),
    transferable: (id: string) => ({
        queryKey: ['transferable', id],
        queryFn: () => PrepaidCardApi.getTransferableCards(id),
    }),
    giftBoxCount: () => ({
        queryKey: ['giftBoxCount'],
        queryFn: () => PrepaidCardApi.getGiftBoxCount(),
    }),
    giftBoxes: (size: number = 10) => ({
        queryKey: ['giftBoxes', size],
        queryFn: () => PrepaidCardApi.getGiftBoxes(0, size),
    }),
    giftBox: (id: string) => ({
        queryKey: ['giftBox', id],
        queryFn: () => PrepaidCardApi.getGiftBox(id),
    }),
});

export default userPrepaidCardQueries;
